import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions } from "store";
import { arrayIsEqual, tableColumn } from "utils";
import { ActionButton, TableList } from "components/common";


class SiteNavList extends Component {
  state = {
    columnList: ['name', 'path', 'type', 'sort', 'actions'],
    columnByName: {
      name: tableColumn('Название', 'name', {
        sorter: true,
      }),
      path: tableColumn('Путь', 'path', {
        sorter: true,
      }),
      type: tableColumn('Тип', 'type', {
        width: 100,
        sorter: true,
      }),
      sort: tableColumn('Сортировка', 'sort', {
        width: 80,
        sorter: true,
      }),
      actions: tableColumn('', 'actions', {
        align: 'right',
        render: (val, item) => (
          <ActionButton
            actions={[{
              title: 'Редактировать', key: 'edit', icon: 'edit', action: () => this.showEditForm(item),
            }, {
              title: 'Удалить', key: 'delete', icon: 'delete', action: () => this.delete(item),
              confirm: {
                title: 'Уверены, что хотите удалить?',
                okText: 'Удалить',
                cancelText: 'Отмена'
              }
            }]}
          />
        ),
      }),
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { columnList } = nextProps;
    if (columnList && !arrayIsEqual(prevState.columnList, columnList)) {
      return {
        columnList: columnList,
      }
    }
    return null;
  }

  load = ({ query, activeFilter }) => {
    this.props.actions.siteNavListLoad({ query, activeFilter });
  };

  showEditForm = (item) => {
    this.props.actions.siteNavShowEditForm({ show: true, object: item })
  };

  delete = (item) => {
    this.props.actions.siteNavDelete({ id: item.id })
  };

  render() {
    const { history, defaultFilter, activeFilter, topActions, site_nav } = this.props;
    const { columnList, columnByName } = this.state;

    return (
      <TableList
        history={history}
        data={site_nav}
        defaultFilter={defaultFilter}
        activeFilter={activeFilter}
        topActions={topActions}
        columnList={columnList}
        columnByName={columnByName}
        onLoadData={this.load}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    site_nav: state.site_nav,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.site_nav), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteNavList);